// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8109":"css/admin-app.6649","8690":"css/app.6649"}[chunkId] + ".css";
};